import { createFileRoute } from '@tanstack/react-router';
import { BuStructurePage } from '@/features/workforce/bu/BuStructurePage';
import { MobileBu } from '@/features/workforce/bu/mobile/MobileBu';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';

export const Route = createFileRoute('/_app/workforce/bu')({ component: BuStructure });

/**
 * `/workforce/bu` — la struttura BU: aree di business e gruppi operativi.
 *
 * Sostituisce le due tabelle separate `/workforce/areas` e `/workforce/groups`, che dicevano
 * quali aree e quali gruppi esistono ma non quale gruppo stia in quale area.
 */
function BuStructure() {
  return useIsMobileShell() ? <MobileBu /> : <BuStructurePage />;
}
